import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

interface LoadingProps {}

export const Loading: React.FC<LoadingProps> = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        padding: 0,
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflow: 'scroll',
          pb: 4,
          pt: 1,
        }}
      >
        <Stack spacing={3}>
          {/* Patient Picker Skeleton */}
          <Box>
            <Skeleton variant="text" sx={{width: "40%", height: 24,  mb: 1 }} />
            <Skeleton variant="rectangular"  sx={{ height: 56 }}/>
          </Box>

          {/* Appointment Type Skeleton */}
          <Box>
            <Skeleton variant="text" sx={{width: "50%", height: 24,  mb: 1 }} />
            <Skeleton variant="rectangular"  sx={{ height: 56 }}/>
          </Box>

          {/* Duration Schedule Skeleton */}
          <Box>
            <Skeleton variant="text" sx={{width: "30%", height: 24,  mb: 1 }} />
            <Stack direction="row" spacing={2}>
              <Skeleton variant="rectangular" sx={{height: 56,  flex: 1 }} />
              <Skeleton variant="rectangular" sx={{height: 56,  flex: 1 }} />
            </Stack>
          </Box>

          {/* Forms Section Skeleton */}
          <Box>
            <Skeleton variant="text" sx={{width: "25%", height: 24,  mb: 1 }} />
            <Skeleton variant="rectangular"  sx={{ height: 120 }}/>
          </Box>

          {/* Reminders Section Skeleton */}
          <Box>
            <Skeleton variant="text" sx={{width: "30%", height: 24,  mb: 1 }} />
            <Skeleton variant="rectangular"  sx={{ height: 80 }}/>
          </Box>
        </Stack>
      </Box>

      {/* Bottom Action Bar Skeleton */}
      <Box
        sx={{
          mx: -2,
          p: 2,
          borderTop: '1px solid',
          borderColor: 'divider',
          position: 'sticky',
          bottom: 0,
          background: 'background.paper',
          zIndex: 1,
        }}
      >
        <Stack direction="row" spacing={4} sx={{ justifyContent: "space-between" }}>
          <Skeleton variant="rectangular"  sx={{ width: 140, height: 36 }}/>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="rectangular"  sx={{ width: 100, height: 36 }}/>
            <Skeleton variant="rectangular"  sx={{ width: 100, height: 36 }}/>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
